export const PasswordInputStrings = {
    PASSWORD: "Password"
};
